import { render, staticRenderFns } from "./JiraQaImportList.vue?vue&type=template&id=2a30a1da&scoped=true"
import script from "./JiraQaImportList.vue?vue&type=script&lang=js"
export * from "./JiraQaImportList.vue?vue&type=script&lang=js"
import style0 from "./JiraQaImportList.vue?vue&type=style&index=0&id=2a30a1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a30a1da",
  null
  
)

export default component.exports